module.exports = __webpack_public_path__ + "media/audio10.1baab725.mp3";